const lang = {
  'global.role': 'Rôle',
  'global.add': 'Créer',
  'global.route_markets': 'Canaux de vente',
  // 'global.edit': 'Sửa',
  'global.password': 'Mot de passe',
  'global.resetpassword': 'Réinitialiser le mot de passe',
  'global.input_password': 'Entrez le mot de passe',
  'global.is_verified_email': "Vérifier l'email",
  'global.collaborator': 'Collaborateur',
  'global.is_mobile_verified': 'Vérifier le téléphone',
  'global.operator_user': 'Utilisateur Compagnie',
  'global.unverified': 'Non vérifié',
  'global.store': 'Magasin',
  'global.verified': 'Vérifié',
  'global.status': 'Statut',
  'global.add_price': 'Ajouter un prix',
  'global.add_new': 'Créer nouveau',
  'global.published': 'Publié',
  'global.unpublished': 'Non publié',
  'global.delete': 'Supprimer',
  'global.copy': 'Copier',
  'global.create': 'Ajouter',
  'global.update': 'Mettre à jour',
  'global.image': 'Image',
  'global.image_alt': "Texte alternatif de l'image",
  'global.schema_type': 'Type de schéma',
  'global.title': 'Titre',
  'global.slug': 'Slug',
  'global.sub_title': 'Sous-titre',
  'global.company': 'Compagnie',
  'global.id': 'ID',
  'global.tabbasic': 'Basique',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Annuler',
  'global.active': 'Actif',
  'global.deactivate': 'Inactif',
  'global.submit': 'Soumettre',
  'global.edit': 'Modifier',
  'global.trashed': 'Corbeille',
  'global.approved': 'Approuvé',
  'global.approve': 'Approuver',
  'global.from': 'Départ',
  'global.to': 'Arrivée',
  'global.price_discount': 'Prix réduit',
  'global.price_roundtrip': 'Prix aller-retour',
  'global.price': 'Prix',
  'global.infant_price': 'Prix bébé',
  'global.car': 'Voiture',
  'global.type': 'Type',
  'global.rating': 'Note',
  'global.room_rate': 'Tarif chambre',
  'global.cancel_policy': "Politique d'annulation",
  'global.instant_bookable': 'Réservation instantanée',
  'global.yes': 'Oui',
  'global.no': 'Non',
  'global.city': 'Ville',
  'global.street': 'Rue',
  'global.neighbourhood_cleansed': ' Quartier nettoyé',
  'global.neighbourhood_group_cleansed': ' Groupe nettoyé',
  'global.location': 'Emplacement',
  'global.choose-location': "Choisir l'emplacement",
  'global.square_feet': 'Pieds carrés',
  'global.bedrooms': 'Chambres',
  'global.bathrooms': 'Salles de bain',
  'global.beds': 'Lits',
  'global.bed_type': 'Type de lit',
  'global.cover_img': 'Image de couverture',
  'global.gallery': 'Galerie',
  'global.gallerySetting': 'Paramètres de la galerie',
  'global.security_deposit': 'Dépôt de garantie',
  'global.guests_included': 'Invités inclus',
  'global.minimum_nights': 'Nuits minimum',
  'global.cleaning_fee': 'Frais de nettoyage',
  'global.extra_people': 'Personnes supplémentaires',
  'global.maximum_nights': 'Nuits maximum',
  'global.months': 'Mois',
  'global.calendar': 'Calendrier',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Arrondissement',
  'global.no_house': 'Numéro de maison',
  'global.nearbyUtils': 'Utilitaires à proximité',
  'global.extra_price': 'Prix supplémentaire',
  'global.patients': 'Patients',
  'global.setting': 'Paramètre',
  'global.appointments': 'Rendez-vous',
  'global.suppliers': 'Fournisseurs',
  'global.id_number': "Numéro d'identification",
  'global.code': 'Code',
  'global.name': 'Nom',
  'global.services': 'Services',
  'global.clinic': 'Clinique',
  'global.website': 'Site web',
  'global.contact_name': 'Contact',
  'global.refresh': 'Actualiser',
  'global.distance': 'Distance',
  'global.update_success': 'Mise à jour réussie !',

  'car.driver': 'Chauffeur',
  'car.seat': 'Siège',
  'car.luggage': 'Bagages',
  'car.ordering': 'Réservation',
  'car.facility': 'Équipement',
  'car.air_machine': 'Climatisation',
  'car.energy_saving': "Économie d'énergie",
  'car.stop_point': 'Arrêt',
  'property.start_date': 'Date de début',
  'property.end_date': 'Date de fin',
  'property.price_week': 'Prix semaine',
  'property.weekend_price': 'Prix weekend',
  'property.extra_price': 'Prix supplémentaire',
  'property.host_languages': " Langues de l'hôte",
  'property.week_term_promo': 'Promotion semaine',
  'property.month_term_promo': 'Promotion mois',
  'property.price_weekend': 'Prix weekend',
  'global.guests_standard': 'Invités standard',
  'global.guests_max': 'Invités max',
  'sidebar.transport': 'Transport',
  'sidebar.amenity': 'Commodité',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.property': 'Propriété',
  'sidebar.property_type': 'Type de propriété',
  'sidebar.room': 'Chambre',
  'sidebar.cancel_policy': "Politique d'annulation",
  'sidebar.vehicle': 'Véhicule',
  'sidebar.car': 'Voiture',
  'sidebar.route': 'Itinéraire',
  'sidebar.routes': 'Routes',
  'sidebar.inbox': 'Boîte de réception',
  'sidebar.conversation': 'Conversation',
  'sidebar.reservations': 'Réservations',
  'sidebar.earning': 'Gains',
  'sidebar.calendar': 'Calendrier',
  'sidebar.reports': 'Rapports',
  'sidebar.services': 'Services',
  'sidebar.addons_order': 'Services supplémentaires',
  'sidebar.debt_confirmation_record': 'Enregistrement de confirmation de dette',
  'global.requiredfield': 'Champ obligatoire',
  'global.numberfield': 'Le champ doit être un nombre',

  'property.room_type': 'Type de chambre',
  'global.propertytypes': 'Type de propriété',
  'global.save': 'Valider',
  'global.save_and_close': 'Ajouter et fermer',
  'global.signin': 'Se connecter',
  'global.signup': "S'inscrire",
  'global.forgot_password': 'Mot de passe oublié',
  'global.search_placeholder': 'Rechercher',

  'global.sms_settings': 'Notifications',
  'global.app_settings': 'Applications',

  'global.disabled': 'Désactivé',
  'global.enabled': 'Activé',

  //sms settings
  'global.sender_id': "ID de l'expéditeur",
  'global.user_app': 'Application utilisateur',
  'global.operator_app': 'Application Compagnie',

  //user app settings
  'global.app_listing': 'Liste des applications',
  'global.app_status': "Statut de l'application",
  'global.booking_message': 'Message de réservation',
  'global.booking': 'Réservation',
  'global.selling_start': 'Début de vente',
  'global.any_time': 'À tout moment',
  'global.custom': 'Personnalisé',

  //Tour
  'global.duration': 'Durée',
  'global.routes': 'Routes',
  'global.category': 'Catégorie',
  'global.cover_image': 'Couverture',
  'global.url': "URL de l'image",
  'global.operator': 'Compagnie',
  'global.from_price': 'Prix',
  'global.itinerary': 'Itinéraire',
  'global.itineraries': 'routes',
  'global.updated_at': 'Mis à jour le',
  'global.from_priceMGMT': 'Prix',
  'global.from_price_setting': ' Paramètres de prix',
  'global.tours': 'Visites',
  'global.transportation': 'Transport',
  'global.score': 'Score',
  'global.tour_option': 'Options de visite',
  'global.hourly': 'Horaire',
  'tour.title': 'Titre',
  'global.select_category': 'Sélectionner la catégorie',
  'global.select_operator': "Sélectionner l'Compagnie",
  'global.select_cabin_type': 'Sélectionner le type de cabine',
  'tour.description': 'Description de la visite',
  'tour.inclusion': 'Inclusion',
  'tour.exclusion': 'Exclusion',
  'global.inactive': 'Inactif',
  'global.meal': 'Repas',
  'global.category_operator': 'Catégorie et Compagnie',
  'tour.pricing': 'Modèle de tarification',
  'tour.special': 'Spécial',
  'tour.normal': 'Normal',
  'tour.featured': 'En vedette',
  'tour.time_mgmt': 'Gestion du temps',
  'tour.duration_unit': 'Unité de durée',
  'tour.duration': 'Durée',
  'tour.start_time': 'Départ',
  'tour.instant_confirm': 'Confirmation instantanée',
  'global.delete_confirm': 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  'global.cancel_order': 'Êtes-vous sûr de vouloir annuler cet élément ?',
  'tour.gallery': 'Galerie',
  'global.ticket': 'Billet',
  'global.display': 'Affichage',
  'global.min_person': 'Personne minimum',
  'global.freeCancelHours': "Heures d'annulation gratuite",
  'global.freeCancel': 'Annulation gratuite',
  'tour.freeCancel': 'Annulation gratuite',
  'global.cancelPolicy': "Politique d'annulation",
  'global.meeting': 'Point de rencontre',
  'global.meetingPoint': 'Point de rencontre',
  'global.meeting_point': 'Point de rencontre',
  'global.meeting_point_type': 'Type de point de rencontre',
  'global.meetingPointNotes': 'Notes du point de rencontre',
  'tour.cutOffTime': 'Heure limite (heures)',
  'tooltip.cutOffTime':
    'Par exemple : 2 jours avant la date de départ équivaut à 48 heures',
  'global.perPerson': 'Par personne',
  'global.perGroup': 'Par groupe',
  'global.optionTitle': "Titre de l'option",
  'global.checkall': 'Tout cocher',

  'global.show_seat_map': 'Afficher le bus',

  //trajet
  'global.trajet': 'Trajet',
  'global.lieu_arrivee': "Lieu d'arrivée",
  'global.heure_ramassage': 'Heure de prise en charge',
  'global.heure': 'Heure',
  'global.lieu_depart': 'Lieu de départ',
  'global.depart': 'Départ',
  'global.arrivee': 'Arrivée',
  'global.prix': 'Prix',
  'global.sous_trajet_id': 'Id du sous-trajet',
  'global.code_trajet': 'Code du trajet',
  'global.policy': 'Politique',
  'global.app_id': "ID de l'application",

  'global.collaborators': 'Collaborateurs',

  //Seatmap
  'global.chosen': 'Choisi',
  'global.taken': 'Pris',
  'global.locked': 'Verrouillé',
  'global.free': 'Libre',

  //Option
  'global.max_person': 'Personne maximum',
  'global.max': 'Max',
  'global.adult_price': 'Prix adulte',
  'global.child_price': 'Prix enfant',
  'global.cost_price': 'Prix coûtant',
  'global.cost': 'Coût',
  'global.selling_price': 'Prix de vente',
  'global.selling': 'Vente',
  'global.cost_price_notes': 'Notes du prix coûtant',
  'global.select_tour': 'Sélectionner la visite',
  'global.option': 'Option',
  'global.options': 'Options',
  'option.group': 'Groupe',
  'global.Vehicle_type': 'Type de véhicule',
  'global.timeStart': 'Heure de début',
  'global.startWorkingTime': 'Heure de début de travail',
  '.endWorkingTime': 'Heure de fin de travail',

  //Destination
  'global.destination': 'Destination',
  'global.select_destination': 'Sélectionner la destination',
  'global.countries': 'Pays',
  'global.select_country': 'Sélectionner le pays',
  'destination.longitude': 'Longitude',
  'destination.latitude': 'Latitude',
  'global.destination_parent': 'Destination parent',

  //Categories
  'global.categories': 'Catégories',

  //Operators
  'global.operators': 'Compagnies',
  'global.firstname': 'Prénom',
  'global.lastname': 'Nom',
  'global.email': 'Email',
  'global.phone': 'Téléphone',
  'global.hotline': "Ligne d'assistance",
  'global.params': 'Paramètres',
  'global.limit_order_start_time': 'Heure limite de début de commande',
  'global.allow_change_order_after_departure_hour':
    "Autoriser la modification de la commande après l'heure de départ",
  'global.allow_change_order_after_departure':
    'Autoriser la modification de la commande après le départ',
  'global.allow_change_order_before_departure':
    'Autoriser la modification de la commande avant le départ',
  'global.tax_rate': 'Taux de taxe',

  //Currencies
  'global.currencies': 'Devise',
  'currency.name': 'Nom',
  'currency.display': 'Affichage',
  'currency.exchange_rate': 'Taux de change',
  'currency.thousand': 'Format',
  'currency.image': 'Icône',
  'currency.symbol': 'Symbole',
  //post
  'global.posts': 'Articles',
  'post.fulltext': 'Texte complet',
  'post.short': 'Court',
  'global.featured': 'En vedette',
  'post.hit': 'Vue',
  'post.metadesc': 'Meta description',
  'post.metakey': 'Meta key',
  'post.image': 'Image',

  //home
  'global.total_booking_today': 'Réservations',
  'global.total_segments': 'Segments',
  'global.total_revenue_today': 'Revenus',
  'global.total_seat_today': 'Sièges',
  //Log-in Log-out
  'global.account_information': 'Informations de compte',
  'global.signout': 'Se déconnecter',
  'global.email_required': 'Email requis',
  'global.password_required': 'Mot de passe requis',
  'global.email_not_valid': 'Email non valide',

  //Site:
  'global.site': 'Site',
  'sites.hotline': "Ligne d'assistance",
  'sites.locale': 'Langue',
  'sites.from_email': "Email de l'expéditeur",
  'sites.from_name': "Nom de l'expéditeur",
  'sites.currency': 'Devise',
  'sites.timezone': 'Fuseau horaire',
  'sites.meta_description': 'Meta description',
  'sites.meta_title': 'Meta title',
  'sites.email': 'Email',
  'global.sites': 'Sites',
  //Bookings:
  'global.order': 'Réservation',
  'global.orderId': 'ID de la réservation',
  'global.sell_by': 'Vendu par',
  'order.tour_title': 'Titre de la visite',
  'order.route_title': 'Titre',
  'order.pay_status': 'Statut du paiement',
  'order.order_status': 'Statut de la réservation',
  'order.voucher_status': 'Statut du bon',
  'order.vat_status': 'Statut de la TVA',
  'order.depart_date': 'Date de départ',
  'order.customer': 'Client',
  'order.totalTravelers': 'Nombre total de voyageurs',
  'order.totalPrice': 'Prix total',
  'order.created': 'Réservé le',
  'order.created_by': 'created_by',
  'order.create': 'Créer réservation',
  'order.order_seat': 'Attribution des sièges',
  'global.one_way': 'Aller simple',
  'global.two_way': 'Aller-retour',
  'global.time': 'Heure',
  'global.search': 'Rechercher',
  'global.departure': 'Départ',
  'global.return': 'Retour',
  'global.assign_operator': "Attribuer l'Compagnie",
  'global.assign': 'Attribuer',
  'global.total': 'Total',
  'global.group_code': 'Code',
  'global.update_status': 'Mettre à jour le statut',
  'order.depart/return': 'Départ / Retour',
  'global.cashier': 'Caissier',
  //Customers:
  'global.customers': 'Clients',
  'global.fullname': 'Nom',
  'global.userId': "ID d'utilisateur",
  'global.company_name': "Nom de l'entreprise",
  'global.company_shortname': 'Nom abrégé',
  'global.company_tax_id': 'Numéro de taxe',
  'global.address': 'Adresse',
  'customer.create': 'Ajouter',

  //Orders
  'orders.start_date': 'Date de voyage',
  'orders.total': 'Total',
  'orders.order_status': 'Statut de la commande',
  'orders.created': 'Créé',
  'global.access': 'Accès',
  //Users:
  'global.roles': 'Roles',
  'global.users': 'Utilisateurs',

  //Schedule
  'global.schedule_setting': "Paramètres de l'horaire",
  'global.schedule': 'Horaire',
  'global.start_date': 'Date de voyage',
  'global.end_date': 'Date de fin',
  'global.weekdays': 'Jours de la semaine',

  'global.weekday': 'Jour de la semaine',
  'global.statistic': 'Statistique',
  'global.view_seat_map': 'Afficher le Plan du véhicule',
  'global.booked_seat': 'Siège réservé',
  'global.disabled_seats': 'Sièges désactivés',
  'global.preview_seat_map': 'Prévisualiser le Plan du véhicule',

  'global.disabled_seat': 'Désactiver le siège',
  'global.enable_seat': 'Activer le siège',
  //wishlist
  'global.wishlist': 'Liste de souhaits',
  'wishlist.tour_title': 'Titre de la visite',
  'wishlist.customer': 'Client',
  'global.basic': 'Basique',
  'global.item': 'Élément',
  'global.items': 'Éléments',
  'global.sku': 'SKU',
  'global.widgets': 'Widgets',
  'global.widget': 'Widget',

  //menus
  'global.menus': 'Menus',
  'global.menu': 'Menu',
  'global.key': 'Clé',
  'global.menu_items': 'Éléments de menu',
  'global.menu_item': 'Élément de menu',

  //Register
  'global.registration_header': "Formulaire d'inscription",
  'global.country': 'Pays',
  'global.mobile': 'Mobile',
  'signup.back_to_login': 'Retour à la connexion',
  'global.continue': 'Continuer',
  'global.close': 'Fermer',

  //
  'global.statistics': 'Statistiques',
  'global.tour_rates': 'Tarifs',
  'global.tour_options': 'Options',
  'global.destinations': 'Destinations',
  'global.orders': 'Réservations',
  'global.reviews': 'Avis',

  'global.language': 'Langue',
  'global.currency': 'Devise',
  'global.your_plan': 'Forfait',
  'global.trial_end': "Date d'expiration",
  'global.timezone': 'Fuseau horaire',
  'global.emai_required': 'Email requis',
  // 'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email non valide',
  'global.confirm_password': 'Confirmer le mot de passe',
  'global.changepassword': 'Changer le mot de passe',
  'global.confirm_new_password': 'Confirmer le nouveau mot de passe',
  'global.new_password': 'Nouveau mot de passe',
  'global.current_password': 'Mot de passe actuel',
  'global.password_not_match': 'Les mots de passe ne correspondent pas',
  'global.password_min_charactor': '6 caractères minimum',
  'global.home': 'Accueil',

  'global.please_select_start_and_stop_destination':
    "Veuillez sélectionner les destinations de départ et d'arrivée",

  // Cabins
  'global.cabins': 'Cabines',
  'global.size': 'Taille',
  'global.qty': 'Quantité',
  'global.route': 'Trajet',

  // Customer Groups
  'global.discount': 'Remise',
  'global.cGroups': 'Groupes de clients',
  'global.group': 'Groupe',

  //
  'global.hops': 'Étapes',
  'global.systems': 'Systèmes',
  'global.start_time': 'Heure de début',
  'global.start_stop': 'Destination de départ',
  'global.end_stop': "Destination d'arrivée",
  'global.cabin-rates': 'Tarifs des cabines',
  'global.title_route': 'Itinéraire',

  // Addons
  'global.addons': 'Services supplémentaires',
  'global.seat': 'Siège',
  'global.from_date': 'Du',
  'global.to_date': 'Au',

  'global.order_group': 'Groupe de réservation',
  'global.route_tital': 'Itinéraire',
  'global.select_customer': 'Passagers',
  'global.select_option': "Sélectionner l'option",
  'global.order_status': 'Statut de la réservation',
  'global.pay_method': 'Mode de paiement',
  'global.order_cancel': 'Êtes-vous sûr de vouloir annuler cette commande ?',
  'order.pax': 'Passagers',
  'global.passport': 'Passeport',
  'global.addnew': 'Ajouter',
  'global.select_county': 'Sélectionner le comté',
  'global.cabin': 'Cabine',
  'global.price_type': 'Type de prix',
  'global.voucher': 'Bon',
  'global.passengers': 'Passagers',
  'global.notes': 'Notes',
  'global.order_id': 'ID de la réservation',
  'global.select_date': 'Sélectionner la date',
  'global.select_hops': "Sélectionner l'étape",
  'global.pay_status': 'Statut du paiement',
  'bill.serial': 'Numéro de série',
  'bill.billed_date': 'Date de facturation',
  'bill.amount': 'Montant',
  'global.method': 'Mode',
  'global.wave_template_sms': 'Modèle SMS Wave',
  'global.suffix_userapp': 'Suffixe application utilisateur',
  'global.suffix_operatorapp': 'Suffixe application Compagnie',
  'global.is_on_operatorapp': 'Application Compagnie',
  'global.is_on_userapp': 'Application utilisateur',
  'global.fee': 'Frais',
  'global.fee_default': 'Frais par défaut',
  'global.field': 'Champ',
  'global.payment_method': 'Mode de paiement',
  'global.op_payment_method': "Mode de paiement de l'Compagnie",
  'global.seat_lock': 'Verrouillage du siège',
  'global.session': 'Session',
  'global.bills': 'Paiements',
  'global.notpaid': 'Non payé',
  'global.paid': 'Payé',
  'global.collect': 'Collecter',
  'global.spend': 'Dépenser',
  'global.cash': 'Espèces',
  'global.card': 'Carte',
  'global.bank': 'Banque',
  'global.insurance': 'Assurance',
  'global.select_customers': 'Passagers',
  'global.select_types': 'Sélectionner le type',
  'sidebar.dept': 'AR',
  'global.total_debt_begin_period': 'Dette début de période',
  'global.total_paid_begin_period': 'Payé début de période',
  'global.total_debt_in_period': 'Dette dans la période',
  'global.total_paid_in_period': 'Payé dans la période',
  'global.total_debt_end_period': 'Dette totale',

  'global.ar': 'Comptes clients',
  'global.confirm': 'Confirmer',
  'global.order_confirm': 'Êtes-vous sûr de vouloir confirmer cette commande ?',
  'global.bill_confirm': 'Êtes-vous sûr de vouloir approuver cette facture ?',
  // 'global.cabin_rates': 'Cabin rates',
  'global.bookingCalendar': 'Calendrier de réservation',
  'global.invoice': 'Facture',
  'global.list_order_not_paid': 'Liste des commandes non payées',
  'global.export_to_excel': 'Exporter vers Excel',
  'global.report_debt_confirmation': 'Enregistrement de confirmation de dette',
  'global.debt': 'Dossiers AR',
  'global.bill': 'Paiement',
  'global.record': 'Enregistrement',
  // report
  'global.date': 'Date',
  'global.hop': 'Étape',
  'global.addon': 'Service supplémentaire',
  'global.customer': 'Client',
  'global.year': 'Année',

  'global.select_menu': 'Sélectionner le menu',
  'global.select_role': 'Sélectionner le rôle',

  'global.add_walk_in_customer': 'Ajouter un client sans rendez-vous',
  'global.order_details': 'Détails de la réservation',
  'global.cabins_order': 'Commande des cabines',
  'global.last_30_day': '30 derniers jours',
  'global.last_7_day': '7 derniers jours',
  'global.last_month': 'Mois dernier',
  'global.this_month': 'Ce mois-ci',
  'global.next_month': 'Mois prochain',
  'global.seller': 'Vendeur',
  'global.send_email': 'Envoyer un email',
  'global.sale': 'Vente',
  'global.finance': 'Finances',
  'global.carriages': 'Voitures',
  'global.logo': 'Logo',
  'global.content': 'Contenu',
  'global.path': 'Chemin',
  'global.seat_allocation': 'Attribution des sièges',
  'global.cabinSerials': 'Numéros de série des cabines',
  'global.title_carriage': 'Titre de la voiture',
  'global.title_cabin': 'Titre de la cabine',
  'global.select_carriage': 'Sélectionner la voiture',
  'global.order_seat': 'Réserver un siège',
  'global.order_seats': 'Réserver des sièges',
  'global.Seat': 'Siège',
  'global.lock': 'Verrouiller',
  'global.expiration': 'Expiration',
  'global.depart_seating': 'Sièges de départ',
  'global.return_seating': 'Sièges de retour',
  'global.seating': 'Sièges',
  'global.gateway_url': 'URL de la passerelle',
  'global.summary': 'Résumé',
  'global.action': 'Action',
  'global.created_at': 'Créé le',
  'global.created_by': 'Créé par',
  'global.roundtrip': 'Aller-retour',

  'sites.url': 'URL',
  'sites.ga_script': 'Script Google Analytics',
  'global.meta_data': 'Meta Data',
  'global.meta_title': 'Meta titre',
  'global.meta_description': 'Meta Description',
  'global.meta_keywords': 'Meta Keywords',
  'global.before_head': "Avant l'en-tête",
  'global.before_body': 'Avant le corps',
  'global.layout': 'Disposition',
  'global.socials': 'Réseaux sociaux',

  // status
  'global.all': 'Tous',
  'global.pending': 'En attente',
  'global.confirmed': 'Confirmé',
  'global.cancelled': 'Annulé',
  'global.refund': 'Remboursement',
  'global.mark_as_paid': 'Marquer comme payé',

  'global.super': 'Super',
  'global.admin': 'Admin',
  'global.staff': 'Personnel',
  'global.agent': 'Agent',
  'global.upgrade': 'Mettre à niveau',
  'global.cabin_no': 'Numéro de cabine',
  'global.carriage': 'Voiture',
  'global.cabin_type': 'Type de cabine',
  'global.view_seat': 'Voir le siège',
  'global.view': 'Voir',
  'global.ok': 'Ok',
  'global.seats': 'Sièges',
  'global.time_period': 'Période',
  'global.booked_seats': 'Sièges réservés',
  'global.allocated_seat': 'Siège attribué',
  'global.revenue': 'Revenu',
  'global.revenue_report': 'Rapport des revenus',
  'global.cabins_performance': 'Performance des cabines',
  'global.created_date': 'Date de création',
  'global.depart_date': 'Date de départ',
  'global.download': 'Télécharger',
  'global.permission': 'Autorisation',
  'global.permissions': 'Autorisations',
  'permissions.decline': 'Refuser',
  'permissions.allow': 'Autoriser',
  'global.e_ticket': 'Billet électronique',
  'global.internal_notes': 'Notes internes',
  'global.information_customer': 'Informations client',
  'global.cgroup': 'Groupe de clients',
  'global.order_information': 'Informations sur la réservation',
  'global.accountant_email': 'Email du comptable',
  'global.more': 'plus',
  'global.full': 'Complet',
  'global.deposited': 'Déposé',
  'global.payment_type': 'Type de paiement',
  'global.payment_status': 'Statut du paiement',
  'global.contact_information': 'Coordonnées',
  'global.contacts': 'Contacts',
  'global.contact': 'Contact',
  'global.add_contact': 'Ajouter un contact',
  'global.office': 'Bureau',
  'global.select_contact': 'Sélectionner le contact',
  'global.select_seller': 'Sélectionner le vendeur',
  'global.input_group_code': 'Entrez le code',
  'global.input_pax': 'Entrez les passagers',
  'global.input_order_notes': 'Entrez les notes de commande',
  'global.input_order_internal_notes': 'Entrez les notes internes',
  'global.input_contact_name': 'Entrez le nom du contact',
  'global.input_contact_email': "Entrez l'email du contact",
  'global.input_contact_mobile': 'Entrez le mobile du contact',
  'validate.is_not_email': "Le champ n'est pas un email",
  'validate.is_not_phone_number': "Le champ n'est pas un numéro de téléphone",
  'order.select_other_contact': 'Autre',
  'global.select_hop': 'Sélectionner une étape',
  'global.select_route': 'Sélectionner un itinéraire',
  'global.book': 'Réserver',
  'global.user': 'Utilisateur',
  'global.save_success': 'Enregistrement réussi',
  'global.save_failed': "Échec de l'enregistrement",
  'global.guide_number': 'Guide',
  'global.input_guide_number': 'Entrez le guide',
  'global.input_your_password': 'Veuillez entrer votre mot de passe !',
  'global.input_beds': 'Veuillez entrer le nom des lits ou supprimer ce champ',
  'global.input_email_or_delete':
    "Veuillez entrer le nom de l'e-mail ou supprimer ce champ",
  'global.select_destination_start': 'Sélectionner la destination de départ',
  'global.select_destination_end': "Sélectionner la destination d'arrivée",
  'placeholder.select_hop': "Sélectionner l'étape",
  'placeholder.select_addon': 'Sélectionner un service supplémentaire',
  'placeholder.from': 'Départ',
  'placeholder.to': 'Arrivée',
  'placeholder.select_category': 'Sélectionner la catégorie',
  'placeholder.select_customer_group': 'Sélectionner le groupe de clients',
  'global.select_user': "Sélectionner l'utilisateur",
  'placeholder.select_user': "Sélectionner l'utilisateur",
  'global.select_permission': "Sélectionner l'autorisation",
  'global.select_all': 'Tout sélectionner',
  'global.advanced_settings_for_each_user':
    'Paramètres avancés pour chaque utilisateur',
  'note.reload_page':
    'Vous devez recharger la page après avoir terminé la modification',
  'global.history': 'Historique',
  'global.clear': 'Effacer',
  'history.from_date': 'De',
  'history.to_date': 'À',
  'history.week_days': 'Jours de la semaine',
  'global.reload': 'Recharger',
  'global.clear_rate_confirm': 'Êtes-vous sûr de vouloir effacer ces données ?',
  'placeholder.booking_id_or_code': 'ID de réservation ou code',
  'global.special_notes': 'Notes spéciales',
  'placeholder.input_special_notes': 'Entrez les notes spéciales',
  'global.choice_a_time_period': 'Choisir une période',
  'global.not_found': 'Introuvable',
  'global.select_a_customer': 'Sélectionner un client',
  'placeholder.select_customer': 'Passagers',
  'placeholder.input_notes': 'Entrez les notes',
  'placeholder.input_description': 'Entrez la description',
  'placeholder.select_creator': 'Sélectionner le créateur',
  'placeholder.select_status': 'Sélectionner le statut',
  'placeholder.payment_from': 'Paiement de',
  'placeholder.payment_to': 'Paiement à',
  'global.initialization_time': "Temps d'initialisation",
  'placeholder.input_title': 'Entrez le titre',
  'placeholder.input_code': 'Entrez le code',
  'placeholder.select_route': "Sélectionner l'itinéraire",
  'error.quantity_is_not_the_same':
    "La quantité n'est pas la même que la quantité commandée",
  'global.addons_booking': 'Services supplémentaires',
  'error.missing_addon': 'Veuillez sélectionner un service supplémentaire',
  'warning.not_found_carriages': 'Aucune voiture disponible',
  'global.individual': 'Individuel',
  'global.available': 'Disponible',
  'global.booking_statistics': 'Statistiques des réservations',
  'global.total_number_of_tickets': 'Nombre total de billets',
  'global.sold': 'Vendu',
  'global.remaining': 'Restant',
  'global.capacity': 'Capacité',
  'global.general_capacity': 'Capacité générale',
  'global.files_manager': 'Gestionnaire de fichiers',
  'error.upload_file':
    'Erreur lors du téléchargement du fichier. Veuillez réessayer.',
  'success.upload_file': 'Fichier téléchargé avec succès !',
  'global.create_folder': 'Ajouter un dossier',
  'placeholder.input_folder_name': 'Entrez le nom du dossier',
  'global.folder_name': 'Nom du dossier',
  'error.create_folder':
    'Erreur lors de la création du dossier. Veuillez réessayer.',
  'error.delete_file': 'Erreur de suppression, veuillez réessayer.',
  'error.folder_name': 'Nom de dossier non valide, veuillez réessayer.',
  'error.missing_file_upload':
    'Veuillez sélectionner un fichier à télécharger.',
  'placeholder.select_date': 'Sélectionner la date',
  'placeholder.input_email': "Entrez l'email",
  'global.send': 'Envoyer',
  'global.download_addon_booking': 'Télécharger les services supplémentaires',
  'error.send_email': "Erreur lors de l'envoi de l'email. Veuillez réessayer.",
  'global.send_email_success': 'Email envoyé avec succès',
  'global.customer_name': 'Nom du client',
  'global.seated_by': 'Placé par',
  'global.seated_date': 'Date de placement',
  'sidebar.invoice': 'Facture',
  'global.booked_from': 'Réservé de',
  'global.booked_to': 'Réservé à',
  'global.amount_of_money': "Montant d'argent",
  'global.track': 'Suivi',
  'placeholder.input_track': 'Entrez le suivi',
  'global.amenities': 'Équipements',
  'global.icon': 'Icône',
  'error.must_contain_least_one_value':
    'Doit contenir au moins une information sur le passager',
  'global.representative_passenger': 'Passager représentant',
  'placeholder.input_firstname': 'Entrez le prénom',
  'placeholder.input_lastname': 'Entrez le nom de famille',
  'error.missing_passenger_information':
    'Veuillez entrer au moins une information sur le passager',
  'global.refund_policy': 'Politiques de remboursement',
  'global.refund_policies': 'Politiques de remboursement',
  'global.cancel_fee': "Frais d'annulation",
  'global.hours': 'Heures',
  'global.is_default': 'Est par défaut',
  'global.select_tours': 'Sélectionner une visite',
  'global.payments': 'Paiements',
  'global.payment_date': 'Date de paiement',
  'global.payment': 'Paiement',
  'global.refund_recording': 'Enregistrement du remboursement',
  'global.transaction': 'Transaction',
  'global.transactions': 'Transactions',
  'global.penalty_date': 'Date de pénalité',
  'global.today': "Aujourd'hui",
  'global.penalty_status': 'Statut de la pénalité',
  'global.no_payment_yet': 'Aucun paiement pour le moment',
  'global.tour': 'Visite',
  'placeholder.input_amount': 'Entrez le montant',
  'success.refund_recorded': 'Remboursement enregistré',
  'global.adults': 'Adultes',
  'global.children': 'Enfants',
  'global.infants': 'Bébés',
  'global.pickup_location': 'Lieu de prise en charge',
  'global.income': 'Revenu',
  'global.expense': 'Dépense',
  'global.pay': 'Payer',
  'global.debit': 'Débit',
  'global.amount': 'Montant',
  'global.transaction_date': 'Date de la transaction',
  'global.guest_payment_date': 'Date de la transaction',
  'global.policy_penalty_name': 'Nom de la politique de pénalité',
  'global.guest_payment': 'Transaction',
  'global.guest_payment_detail': 'Détail de la transaction',
  'global.waiting_approve': "En attente d'approbation",
  'global.created_payments': 'Paiements créés',
  'tour.pickup_offered': 'Prise en charge proposée',
  'global.pickup_offer': 'Offre de prise en charge',
  'global.both': 'Les deux',
  'global.free_cancel': 'Annulation gratuite',
  'global.penalty': 'Pénalité',
  'global.cancel_booking': 'Annuler la réservation',
  'global.pickup_time': 'Heure de prise en charge',
  'global.create_transaction': 'Ajouter une transaction',
  'global.depart_value': 'Valeur de départ',
  'global.penalty_amount': 'Montant de la pénalité',
  'global.add_pickup': 'Ajouter une prise en charge',
  'global.select_meeting_type': 'Sélectionner le type de point de rencontre',
  'global.book_tour': 'Réserver une visite : ',
  'global.endWorkingTime': 'Heure de fin de travail',

  //payment method
  'global.merchant_id': 'ID du commerçant',
  'global.secret_key': 'Clé secrète',
  'global.notify_url': 'URL de notification',
  'global.identifiant': 'Identifiant',
  'global.error_url': "URL d'erreur",
  'global.success_url': 'URL de succès',
  'global.client_id': 'ID du client',
  'global.merchant_account': 'Compte marchand',
  'global.client_secret': 'Secret client',
  'global.callback_url': 'URL de callback',
  'global.yobuma': 'Yobuma',
  'global.markets': 'Marchés',

  //
  'global.send_link_payment': 'Envoyer le lien de paiement',
  'global.filter_params': 'Filtres',
  'global.category_id': 'Catégorie',
  'global.destination_id': 'Destination',

  'global.market': 'Marché',
  'global.flat': 'Forfait',
  'global.commission_amount': 'Montant de la commission',

  'global.waiting': 'En attente',

  'global.select_operators': 'Sélectionner les Compagnies',
  'order.supplier_status': 'Statut du fournisseur',
  'global.free_cancel_date': "Date d'annulation gratuite",
  'global.time_start': 'Heure de début',
  'global.supplier_total': 'Total fournisseur',
  'global.edit_pickup': 'Modifier la prise en charge',

  'global.drop_off': 'Dépose',
  'global.driver_notes': 'Notes du chauffeur',
  'global.policies': 'Politiques',
  'global.cancellation_policy_summary': 'Annulation',
  'global.service_fee': 'Frais de service',
  'global.ordering': 'Commande',
  'global.price_cron': 'Cron de prix',
  'global.unit': 'Unité',

  'global.subtotal': 'Sous-total',
  'global.refund_amount': 'Montant du remboursement',
  'global.cancellation_date': "Date d'annulation",
  'global.cancellation_fee': "Frais d'annulation",
  'global.cache_reset': 'Réinitialisation du cache',
  'global.additional_info': 'Informations supplémentaires',
  'global.driver': 'Chauffeur',

  'global.select_type': 'Sélectionner le type',
  'global.brand': 'Marque',

  // crm
  'global.crm': 'CRM',
  'global.segments': 'Segments',
  'global.templates': 'Modèles',
  'global.campaigns': 'Campagnes',
  'global.phone_code': 'Code téléphonique',
  'global.action_date': "Date d'action",
  'global.date_of_birth': 'Date de naissance',
  'global.lead_status': 'Statut du prospect',
  'global.new': 'Nouveau',
  'global.open': 'Ouvert',
  'global.in_progress': 'En cours',
  'global.unqualified': 'Non qualifié',
  'global.attempted_to_contact': 'Tentative de contact',
  'global.connected': 'Connecté',
  'global.bad_timing': 'Mauvais timing',
  'global.subscribed': 'Abonné',
  'global.unsubscribed': 'Désabonné',
  'global.owner': 'Propriétaire',
  'global.subject': 'Sujet',
  'global.once': 'Une fois',
  'global.daily': 'Quotidien',
  'global.repeat': 'Répéter',
  'global.audiences': 'Audiences',
  'global.analytics': 'Analytique',
  'global.opened': 'Ouvert',
  'global.schedule_date': 'Date prévue',
  'global.send_now': 'Envoyer maintenant',
  'global.campaign_key': 'Clé de campagne',
  'global.segment': 'Segment',
  'global.template': 'Modèle',
  'global.links': 'Liens',
  'global.conditions': 'Conditions',
  'global.is': 'Est',
  'global.is_not': "N'est pas",
  'global.contain': 'Contient',
  'global.not_contain': 'Ne contient pas',
  'global.start_with': 'Commence par',
  'global.end_with': 'Se termine par',
  'global.send_index': 'Envoyer IndexNow',
  'global.send_success': 'Message envoyé',
  'global.send_failed': 'Message non envoyé',
  'global.source': 'Source',
  'global.apply': 'Appliquer',
  'global.sent': 'Envoyé',
  'global.not_send': 'Non envoyé',
  'global.sent_date': "Date d'envoi",
  'global.recipients': 'Destinataires',
  'global.campaign_status': 'Statut de la campagne',
  'global.running': 'En cours',
  'global.stopped': 'Arrêtée',
  'global.create_segment': 'Ajouter un segment',
  'global.clicked': 'Cliqué',
  'global.start': 'Démarrer',
  'global.stop': 'Arrêter',
  'global.completed': 'Terminé',
  'global.not_open': 'Non ouvert',
  'global.not_click': 'Pas de clic',
  'global.promotions': 'Promotions',
  'global.promotion': 'Promotion',
  'global.used_from': 'Utilisé de',
  'global.used_to': 'Utilisé à',
  'global.used_at': 'Utilisé le',
  'global.discounts': 'Réductions',
  'placeholder.select_group': 'Sélectionner le groupe',
  'global.customer_group': 'Groupe de clients',
  'global.booked_at_from': 'Réservé de',
  'global.booked_at_to': 'Réservé à',
  'placeholder.booked_at_from': 'Réservé de',
  'placeholder.booked_at_to': 'Réservé à',
  'placeholder.used_at_from': 'Utilisé de',
  'placeholder.used_at_to': 'Utilisé à',
  'global.booked_at': 'Réservé le',

  // ROUTE CONFIGURATION
  'global.route_config': "Configuration de l'itinéraire",
  'global.seat_map': 'Plan du véhicule',
  'global.row': 'Rangée',
  'global.column': 'Colonne',
  'global.vehicles': 'Véhicules',
  'global.short_name': 'Nom abrégé',
  'global.user_id': "ID d'utilisateur",
  'placeholder.select_operator': "Sélectionner l'Compagnie",
  'global.serial': 'Numéro de série',
  'placeholder.select_seat_map': 'Sélectionner le Plan du véhicule',
  'global.preview_seat_map': 'Prévisualiser le Plan du véhicule',
  'global.start_location': 'Lieu de départ',
  'global.end_location': "Lieu d'arrivée",
  'global.end_time': 'Heure de fin',
  'global.vehicle': 'Véhicule',
  'placeholder.select_vehicle': 'Sélectionner le véhicule',
  'placeholder.select_start_location': 'Sélectionner le lieu de départ',
  'placeholder.select_end_location': "Sélectionner le lieu d'arrivée",
  'global.destination_map': 'Carte de destination',
  'global.segment_title': 'Titre du segment',
  'global.add_segment': 'Ajouter un segment',
  'global.payment-method': 'Mode de paiement',
  'global.order_no': 'Référence',
  'global.rates': 'Tarifs',
  'global.agency_staff': "Personnel de l'agence",
  'global.add_agency_staff': "Ajouter le personnel de l'agence",
  'global.create_return_route': 'Ajouter un itinéraire de retour',
  'global.settings': 'Paramètres',
  'global.label': 'Libellé :',
  'global.value': 'Valeur',
  'global.create_price_ddd': 'Ajouter un prix DDD',
  'global.recentActivity': 'Journal',
  'global.username': "nom d'utilisateur",
  'global.tax': 'Taxe',
  'global.day': 'Jour',
  'global.booking_statistic': 'Report de voyage',
  'global.trajet_id': 'ID du trajet',
  'global.group_route': 'Grouper par itinéraire',
  'global.default': 'Système par défaut',
  'global.sms_payment': 'Payer',
  'global.ticket_settings': 'Paramètres du billet',
  'global.code_type': 'Type de code',
  'global.qr_code': 'Code QR',
  'global.bar_code': 'Code-barres',
  'global.filling_rate': 'Taux de remplissage',
  'global.trips': 'Voyages',
  'order.reseller': 'Reseller',
  'order.booking_time': 'Booking time',
  'order.rebook': 'Réservation',
  'global.add_new_customer': 'Ajouter passager',
  'global.payment_methods': 'liste des moyens de paiement',
  'global.departure_info': 'informations de voyage',
  'route.create': 'Créer une route',
  'global.valider': 'Valider',
  'global.sms_gateway': 'passerelle SMS',
  'global.orangeSms': 'Orange SMS',
  'global.mtargetSms': 'Mtarget SMS',

  'global.month': 'mois',
  'global.route_code': 'Route',
  'global.depart_time': 'Heure Départ',
  'global.arrival_time': 'Heure Arrivée',
  'global.current_price': 'Prix',
  'global.bus': 'Véhicule',
  'global.bus_type': 'Véhicule Statut',
  'global.export': 'Exporter',
  'select.convoyeur': 'Convoyeur',
  'select.partner_manager': 'Partner Manager',
  'select.partner_admin': 'Partner Admin',
  'select.supervisor': 'Superviseur',
  'select.manager': 'Manager',
  'select.admin': 'Admin',
  'select.operator': 'Opérateur',
  'select.cashier': 'Caissier',
  'global.identify': 'Identifiant',

  'global.required_field_firstname': 'Le prénom est requis',
  'global.required_field_lastname': 'Le nom de famille est requis',
  'global.required_field_email': "L'email est requis",
  'global.required_field_mobile': 'Le mobile est requis',
  'global.required_field_password': 'Le mot de passe est requis',
  'global.required_field_confirm_password':
    'Confirmer le mot de passe est requis',
  'global.required_field_company_name': "Le nom de l'entreprise est requis",
  'global.required_field_company_shortname':
    "Le nom abrégé de l'entreprise est requis",
  'global.required_field_role': 'Le rôle est requis',

  'global.sale_status': 'Actif/Désactivé',
  'global.sale_fee': 'Commission',
  'global.sale_currency_main': 'Devise',
  'global.sale_currency_symbol': 'Symbole',
  'global.sale_currency_display': 'Affichage devise',
  'global.sale_currency_decimald': 'Décimal',

  'global.cancel_hold_time': 'Délai annulation réservation',
  'global.limit_order_days': 'Délai limite de réservation',
  'global.limit_order_minutes': 'Temps limite de réservation',

  'global.sale_edit_enable': 'Actif/Désactivé',
  'global.sale_edit_days': 'Voyage',
  'global.sale_edit_times': 'Nombre de changement',

  'global.enable_disable': 'Activer/Désactiver',
  'global.enable': 'Activer',
  'global.disable': 'Inactif',
  'global.select_status_enable_disable': 'Sélectionner le statut',
  'global.select_enable': 'Sélectionner Activer',
  'global.select_disable': 'Sélectionner Désactiver',
  'global.template_sms': 'SMS Template',
  'global.sms': 'SMS',
  'global.message': 'Message',
  'global.smsActivity': 'SMS',
  'global.number_sms': 'Nombre de SMS envoyés',
  'global.provider': 'Fournisseur',
  'global.account': 'Compte ',
  'global.cashier': 'Caissier',
};
export default lang;
